import { render, staticRenderFns } from "./export-panel.vue?vue&type=template&id=2bb4564c&scoped=true"
import script from "./export-panel.vue?vue&type=script&lang=js"
export * from "./export-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb4564c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bb4564c')) {
      api.createRecord('2bb4564c', component.options)
    } else {
      api.reload('2bb4564c', component.options)
    }
    module.hot.accept("./export-panel.vue?vue&type=template&id=2bb4564c&scoped=true", function () {
      api.rerender('2bb4564c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/send-list-update/export-panel.vue"
export default component.exports